export function removeNonDigits(value: string): string {
    return value.replace(/[^\d]+/gm, '');
}

export function removeWhitespaces(value: string): string {
    return value.replace(/\s+/gm, '');
}
